import { useMessageToState } from "./useMessageToState";

function getSelectedZone(editor: eXpress.core.IEditor) {
	return editor.selection.getCurrentZone() || undefined;
}

/** Return the selected zone */
export function useSelectedZone() {
	return useMessageToState({
		name: "useSelectedZone",
		getState: getSelectedZone,
		filterMessage: eXpress.core.isSelectedZoneChanged,
	});
}

function getLogicalSelectedPage(editor: eXpress.core.IEditor) {
	return editor.selection.getLogicalSelectedPage() || undefined;
}

/** Return the selected page */
export function useLogicalSelectedPage() {
	return useMessageToState({
		name: "useLogicalSelectedPage",
		getState: getLogicalSelectedPage,
		filterMessage: (m) =>
			// Zone selection changed
			eXpress.core.isSelectedZoneChanged(m) ||
			// Spread is changed
			eXpress.core.isSelectedSpreadChanged(m) ||
			// Zone is moved/scaled to another page
			m instanceof eXpress.core.ZoneTransformedMessage ||
			// Page is replaced (implements ISelectionMessage but that does not contain page)
			m instanceof eXpress.core.ReplacedPageMessage,
		// Also for applying templates? currently we cannot select a right page zone and apply a template
	});
}

function getCurrentSpread(editor: eXpress.core.IEditor) {
	return editor.selection.getCurrentSpread();
}

/** Return the selected spread */
export function useSelectedSpread() {
	return useMessageToState({
		name: "useSelectedSpread",
		getState: getCurrentSpread,
		filterMessage: eXpress.core.isSelectedSpreadChanged,
	});
}
